'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var quantityChange = function quantityChange(_ref) {
  var newQuantity = _ref.newQuantity,
      inventory = _ref.inventory,
      type = _ref.type,
      id = _ref.id,
      key = _ref.key;

  if (newQuantity > inventory) {
    PubSub.publish(_Constants2.default.showModal, { name: 'not-enough-inventory', data: { newQuantity: newQuantity, inventory: inventory } });
  } else if (newQuantity >= 1 && type === 'product') {
    // change quantity on product page (but no quantity selects on product page)
    // PubSub.publish(/* update product container quantity */, { id, key, quantity: newQuantity });
  } else if (newQuantity >= 1 && type === 'line-item') {
    PubSub.publish(_Constants2.default.updateLineItemQuantity, { id: id, key: key, quantity: newQuantity, openInlineCart: false });
  } else if (newQuantity === 0 && type === 'line-item') {
    PubSub.publish(_Constants2.default.removeFromCart, { id: id, key: key });
  }
};

var handleQuantityChangeClick = function handleQuantityChangeClick(_ref2) {
  var self = _ref2.currentTarget;

  var change = parseInt(self.dataset.quantityChange, 10);
  var container = $(self).closest(_Dom2.default.container)[0];
  var _container$dataset = container.dataset,
      type = _container$dataset.container,
      id = _container$dataset.containerId;

  var _State$get = State.get(id),
      quantity = _State$get.quantity,
      inventory = _State$get.inventory,
      key = _State$get.key;

  var newQuantity = quantity + change;

  quantityChange({ newQuantity: newQuantity, inventory: inventory, type: type, id: id, key: key });

  return false;
};

var handleQuantityValueChange = function handleQuantityValueChange(_ref3) {
  var self = _ref3.currentTarget;

  var newQuantity = self.value;
  var container = (0, _Helpers.getContainer)({ self: self, type: 'product' }) || (0, _Helpers.getContainer)({ self: self, type: 'line-item' });

  var _container$dataset2 = container.dataset,
      type = _container$dataset2.container,
      id = _container$dataset2.containerId;

  var _State$get2 = State.get(id),
      inventory = _State$get2.inventory,
      key = _State$get2.key;

  quantityChange({ newQuantity: newQuantity, inventory: inventory, type: type, id: id, key: key });

  return false;
};

var bindActions = exports.bindActions = function bindActions() {
  $(document).on('click', _Dom2.default.quantityChange, (0, _Helpers.debounce)(handleQuantityChangeClick, 350));
  $(document).on('change', _Dom2.default.quantityValue, (0, _Helpers.debounce)(handleQuantityValueChange, 350));
};